import descriptionDefaultValue from '../../LearningPlan/Course/components/checklist/descriptionValue'
import { Read } from '../../Editor'

const Description = (props) => (
	<div className='checklist-description'>
		<div className='quiz-row-wrapper richEditorStyles'>
			<Read
				content={
					Object.keys(props.description).length
						? props.description
						: descriptionDefaultValue
				}
			/>
		</div>
	</div>
)

export default Description
